import {animate, state, style, transition, trigger} from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
  state(
    'open',
    style({
      opacity: 1,
    }),
  ),
  state(
    'close',
    style({
      opacity: 0,
    }),
  ),
  transition('open => close', [animate('240ms cubic-bezier(0.4, 0, 0.2, 1)')]),
  transition('close => open', [animate('240ms cubic-bezier(0.4, 0, 0.2, 1)')]),
]);

export const slideInOut = trigger('slideInOut', [
  state(
    'open',
    style({
      transform: 'none',
    }),
  ),
  state(
    'close',
    style({
      transform: 'translateX(100%)',
    }),
  ),
  transition('open => close', [animate('240ms cubic-bezier(0, 0, 0.2, 1)')]),
  transition('close => open', [animate('240ms cubic-bezier(0, 0, 0.2, 1)')]),
]);
